/*
 * @Description: Description
 * @Author: ranli
 * @Date: 2026-04-10 10:28:39
 * @LastEditTime: 2026-04-10 12:56:21
 * @LastEditors: ranli
 */
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import App from './App.vue'
import router from './router'
import './app.less'
// Vant 桌面端适配
import '@vant/touch-emulator'

// Vant 函数组件样式
import 'vant/es/toast/style'
import 'vant/es/dialog/style'
import 'vant/es/notify/style'
import 'vant/es/image-preview/style'

// 自定义弹窗样式
import './components/Toast/style.less'

// 创建应用
const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.use(pinia)
app.use(router)
app.mount('#cricket-app')

